<template>
  <div class="payments check-list-phone" @click.stop="openDialog">
    <el-row class="green">
      <el-col :span="12">оплачено</el-col>
      <el-col :span="12" class="result">
        {{ getRound(payments.payed) }}
      </el-col>
    </el-row>
    <el-row class="orange">
      <el-col :span="12">ожидает</el-col>
      <el-col :span="12" class="result">
        {{ getRound(payments.unpayed) }}
      </el-col>
    </el-row>
    <el-row class="red">
      <el-col :span="12">остаток</el-col>
      <el-col :span="12" class="result">
        {{ getRound(left) }}
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Payment',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
    onPaymentClick: {
      type: Function,
      default: () => {},
    },
    response: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      getPayment: 'reports/getReportModal',
    }),
    pays() {
      return this.getPayment(this.id, 'payment')
    },
    payments() {
      let payed = 0
      let unpayed = 0

      if (this.pays && this.pays.length) {
        this.pays.map(p => {
          if (p.payment_date) {
            payed += p.sum
          } else {
            unpayed += p.sum
          }
        })
      }

      return { payed, unpayed }
    },
  },
  methods: {
    openDialog() {
      this.onPaymentClick(this.response)
    },
  },
}
</script>

<style lang="sass">
.report-response-item
  & .payments
    line-height: 15px
    font-weight: bold
    cursor: pointer
    text-align: left
    margin-top: 10px
    .el-row
      width: 100%
      font-size: 14px
      &.green
        color: #00BF4E
      &.orange
        color: #ffb700
      &.red
        color: #ff0000
      .result
        text-align: right
</style>
